module.exports = __webpack_public_path__ + "img/guinea.cbeb23fa.svg";